import { getOrder } from "../../utils/api";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { SET_PORTAL_API } from "./portal_actions";
import { TITLE_ERROR } from "../../utils/constants";

export const REQUEST_GET_ORDER_SUCCESS = 'EQUEST_GET_ORDER_SUCCESS';
export const REQUEST_GET_ORDER_FAILED = 'REQUEST_GET_ORDER_FAILED';
export const CURR_ORDER_CLEAR = 'CURR_ORDER_CLEAR';
export const CURR_ORDER_SET = 'CURR_ORDER_SET';


export const getCurrOrderThunk = (accessToken, refreshToken, id) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    getOrder(accessToken, refreshToken, id)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ORDER_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_GET_ORDER_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
